jQuery(function ($) {
  var $sticky = $('.stickeytop');
  var $container = $('.stickywrapper');
  var topOffset = 80;
  var mobileBreakpoint = 768;

  function resetSticky() {
    $sticky.css({
      position: '',
      top: '',
      left: '',
      width: '',
      'z-index': ''
    });
  }

  function recalc() {
    // If either element isn't present, bail safely
    if (!$sticky.length || !$container.length) return false;

    // If container is display:none, offset() can be undefined in some cases
    var cOff = $container.offset();
    var sOff = $sticky.offset();
    if (!cOff || !sOff) return false;

    window.stickyHeight = $sticky.outerHeight();
    window.containerTop = cOff.top;
    window.containerHeight = $container.outerHeight();
    window.containerBottom = window.containerTop + window.containerHeight;
    window.origOffsetLeft = sOff.left;
    window.origWidth = $sticky.outerWidth();

    return true;
  }

  function onScrollResize() {
    // If sticky not used on this page, do nothing
    if (!$sticky.length || !$container.length) return;

    if ($(window).width() < mobileBreakpoint) {
      resetSticky();
      return;
    }

    if (!recalc()) {
      resetSticky();
      return;
    }

    var scrollTop = $(window).scrollTop();

    if (scrollTop + topOffset <= window.containerTop) {
      resetSticky();
      return;
    }

    if (scrollTop + topOffset + window.stickyHeight < window.containerBottom) {
      $sticky.css({
        position: 'fixed',
        top: topOffset + 'px',
        left: window.origOffsetLeft + 'px',
        width: window.origWidth + 'px',
        'z-index': 10
      });
      return;
    }

    $sticky.css({
      position: 'absolute',
      top: (window.containerHeight - window.stickyHeight) + 'px',
      left: '',
      width: window.origWidth + 'px',
      'z-index': 10
    });
  }

  // Only bind if it exists on this page
  if ($sticky.length && $container.length) {
    $(window).on('scroll resize', onScrollResize);
    onScrollResize();
  }
});


var nww = jQuery(window).width();
if (nww < 768) {
   $('.tab-sect__tab-info.active-item').each(function(){
      $(this).show();
   });
}
$('.tab-sect__tab').click(function(){
   var newestWindowWidth = jQuery(window).width();
   if (newestWindowWidth < 768) {
      if($(this).hasClass('active-tab')){
         $(this).removeClass('active-tab');
         jQuery(this).siblings('.active-item').removeClass('active-item').slideUp();
      } else{
         jQuery(this).siblings('.active-tab').removeClass('active-tab');
         jQuery(this).siblings('.active-item').removeClass('active-item').slideUp();
         jQuery(this).addClass('active-tab');
         jQuery(this).next().addClass('active-item').slideDown();
      }
	} else {
      var ancestor = $(this).closest('.tab-sect__top');
      var adjAncestor = $(ancestor).siblings('.tab-sect__bottom');
      $(this).siblings('.active-tab').removeClass('active-tab');
      $(this).addClass('active-tab');
      var tabNumber = $(this).data('tabnumber');
      $(adjAncestor).find('.active-item').hide().removeClass('active-item');
      $(adjAncestor).find('.tab-sect__tab-info[data-tabid="' + tabNumber + '"]').fadeIn().addClass('active-item');
   }
});

jQuery(window).on("resize", function (e) {
	checkScreenSize();
});

checkScreenSize();

$('.lightbox-enabled').click(function(){
   var imgURL = $(this).data('lightboximageurl');
   $('#lightbox img').attr('src',imgURL);
   $('#lightbox').fadeIn();
});
$('.lightbox-icon').click(function(){
   var imgURL = $(this).siblings('.lightbox-enabled').data('lightboximageurl');
   $('#lightbox img').attr('src',imgURL);
   $('#lightbox').fadeIn();
});
$('#closeLbox').click(function(){
   $(this).parent('#lightbox').fadeOut();
});

function checkScreenSize(){
	var newWindowWidth = jQuery(window).width();
	if (newWindowWidth < 768) {
		jQuery('.tab-sect__tab-info').each(function(){
			var sectionNo = jQuery(this).data('tabid');
         var insAfter = $(this).parent().siblings('.tab-sect__top').find('.tab-sect__tab[data-tabnumber=' + sectionNo + ']');
			jQuery(this).insertAfter(insAfter);
		});
	} else {
		jQuery('.tab-sect__tab-info').each(function(){
			jQuery(this).appendTo(jQuery(this).closest('.tab-sect__top').siblings('.tab-sect__bottom'));
		});

	}
}
